module.exports = __webpack_public_path__ + "img/logo.d656ff05.svg";